import { FC } from 'react';
import ReactCountdown from 'react-countdown';

const Countdown: FC<{ date: Date }> = ({ date }) => {
  return (
    <ReactCountdown
      date={date}
      renderer={({ days, hours, minutes, seconds }) => {
        return (
          <div className="mx-auto flex max-w-[25rem] justify-between gap-3 text-brand-fire-500">
            <div className="flex h-20 w-[4.625rem] flex-col items-center justify-center rounded-md border border-color-border-input-darkmode bg-brand-gray-900 dark:border-color-border-input-lightmode dark:bg-color-bg-lightmode-tertiary">
              <span className="text-[1.5rem] font-semibold">{days}</span>
              <span className="text-[0.8rem] font-light">Days</span>
            </div>

            <div className="flex h-20 w-[4.625rem] flex-col items-center justify-center rounded-md border border-color-border-input-darkmode bg-brand-gray-900 dark:border-color-border-input-lightmode dark:bg-color-bg-lightmode-tertiary">
              <span className="text-[1.5rem] font-semibold">{hours}</span>
              <span className="text-[0.8rem] font-light">Hours</span>
            </div>

            <div className="flex h-20 w-[4.625rem] flex-col items-center justify-center rounded-md border border-color-border-input-darkmode bg-brand-gray-900 dark:border-color-border-input-lightmode dark:bg-color-bg-lightmode-tertiary">
              <span className="text-[1.5rem] font-semibold">{minutes}</span>
              <span className="text-[0.8rem] font-light">Minutes</span>
            </div>

            <div className="flex h-20 w-[4.625rem] flex-col items-center justify-center rounded-md border border-color-border-input-darkmode bg-brand-gray-900 dark:border-color-border-input-lightmode dark:bg-color-bg-lightmode-tertiary">
              <span className="text-[1.5rem] font-semibold">{seconds}</span>
              <span className="text-[0.8rem] font-light">Seconds</span>
            </div>
          </div>
        );
      }}
    />
  );
};

export default Countdown;
